var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 4H5.00016C4.44788 4 4 4.44771 4 5V12.3333C4 12.8856 4.44771 13.3333 5 13.3333H12.3333C12.8856 13.3333 13.3333 12.8856 13.3333 12.3333V5C13.3333 4.44772 12.8855 4 12.3332 4Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9993 4H19.666C19.1137 4 18.666 4.44771 18.666 5V12.3333C18.666 12.8856 19.1137 13.3333 19.666 13.3333H26.9993C27.5516 13.3333 27.9993 12.8856 27.9993 12.3333V5C27.9993 4.44772 27.5516 4 26.9993 4Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9993 18.6665H19.666C19.1137 18.6665 18.666 19.1142 18.666 19.6665V26.9998C18.666 27.5521 19.1137 27.9998 19.666 27.9998H26.9993C27.5516 27.9998 27.9993 27.5521 27.9993 26.9998V19.6665C27.9993 19.1142 27.5516 18.6665 26.9993 18.6665Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 18.6665H5C4.44772 18.6665 4 19.1142 4 19.6665V26.9998C4 27.5521 4.44771 27.9998 5 27.9998H12.3333C12.8856 27.9998 13.3333 27.5521 13.3333 26.9998V19.6665C13.3333 19.1142 12.8856 18.6665 12.3333 18.6665Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.97873b01c4c2f01578f09d1596272bda.svg";
export { ForwardRef as ReactComponent };